var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg9KeyboardExternal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 1048,
    viewBox: "0 0 1440 1048",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M606.747 553.707C606.892 552.726 607.734 552 608.726 552H735.274C736.266 552 737.108 552.726 737.253 553.707L740.66 576.707C740.839 577.915 739.903 579 738.682 579H605.318C604.097 579 603.161 577.915 603.34 576.707L606.747 553.707Z",
    fill: "#313248"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M606.747 551.707C606.892 550.726 607.734 550 608.726 550H735.274C736.266 550 737.108 550.726 737.253 551.707L740.66 574.707C740.839 575.915 739.903 577 738.682 577H605.318C604.097 577 603.161 575.915 603.34 574.707L606.747 551.707Z",
    fill: "#3E4054"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M699.5 575L697 552.5H698.5L701 575H699.5Z",
    fill: "#2B2D43"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M719.5 560L721 560.5L721.635 565.25H730.5L731 566.75H720.364L719.5 560Z",
    fill: "#2B2D43"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg9KeyboardExternal);
export default __webpack_public_path__ + "static/media/9KeyboardExternal.9ca7e93b183f47ae22cc831600b6c627.svg";
export { ForwardRef as ReactComponent };